export default {
  changeAnswer(state, payload) {
    const questID = state.questions.find(
      (question) => question.id === payload.id
    );
    questID.userAnswerA = parseInt(payload.userAnswerA._value);
    questID.userAnswerB = parseInt(payload.userAnswerB._value);
  },
};
